// DB 날짜 문자열(시간대 없음)은 KST 벽시계라 로컬로 읽는다 — new Date('YYYY-MM-DD') 는 UTC 자정, Safari 는 공백 구분 형식을 못 읽어 직접 나눈다
const LOCAL_DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?)?$/;

function getNewDateObj ( value ) {

    let date;

    switch ( typeof value ) {

        case "undefined":

            date = new Date ();
            break;

        case "string": {

            const m = value.match ( LOCAL_DATE_TIME );

            date = m
                ? new Date ( +m[1], m[2] - 1, +m[3], +( m[4] ?? 0 ), +( m[5] ?? 0 ), +( m[6] ?? 0 ), +( m[7] ?? "" ).padEnd ( 3, "0" ).slice ( 0, 3 ) )
                : new Date ( value );

            break;

        }

        default:

            date = new Date ( value );
            break;

    }

    return date;

}

export default getNewDateObj;
